import * as React from "react";
import styled from "@emotion/styled";
import Button from "@/components/atoms/Button";
import classNames from "classnames";

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 0 30px;
`;

const StyledButton = styled(Button)<{ minWidth?: string }>`
  max-width: 271px;
  min-width: ${({ minWidth = "160px" }) => minWidth};
  height: 48px;
  background-color: #ffffff;
  border: 2px solid #333333;
  border-radius: 24px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  line-height: 35px;
  letter-spacing: 0px;
  color: #333333;
  opacity: 1;
  &.paddingBottom {
    margin-bottom: 108px;
  }
  &.formBtn {
    margin-top: 13px;
    margin-bottom: 90px;
  }
  &.w250 {
  width: 250px;
  }
  &:disabled {
    opacity: 0.7;
  }
`;

type CapsuleNextButtonProps = {
  value: string;
  onClick: () => void;
  disabled?: boolean;
  minWidth?: string;
  className?: string;
};

const CapsuleNextButton = ({ value, onClick, disabled, minWidth, ...props }: CapsuleNextButtonProps) => (
  <ButtonContainer>
    <StyledButton
      onClick={onClick}
      disabled={disabled}
      minWidth={minWidth}
      className={classNames({
        disabled,
        [props.className as string]: typeof props.className === "string" ? true : false,
      })}
    >
      {value}
    </StyledButton>
  </ButtonContainer>
);

export default CapsuleNextButton;
